import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=488064bb&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=488064bb&prod&scoped=true&lang=css"
import style1 from "./Content.vue?vue&type=style&index=1&id=488064bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488064bb",
  null
  
)

export default component.exports